import { render, staticRenderFns } from "./ComfortSelection.vue?vue&type=template&id=8425ba78&scoped=true"
import script from "./ComfortSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComfortSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8425ba78",
  null
  
)

export default component.exports